<template lang="pug">
  div.mapSearch
    div
      div.mapSearch__controllers
        transition(name="fade")
          ods-select.custom_select(
            v-if="geocoding.show"
            v-model='geocoding.value'
            placeholder='Buscar'
            size='mega'
            :filterable="true"
            no-match-text="no existen candidatos"
            remote
            :remote-method='filter'
            @keyup.enter.prevent.native="search"
            @change="setZoom"
            popper-class="custom-popper"
            :remote='true'
          )
            ods-option(
              v-for='item in geocoding.filteredOptions'
              :key='item.value'
              :label='item.name'
              :value='item.id'
              v-loading='geocoding.loading'
            )
              span(style='float: left') {{ item.name | truncate(calculateLength(item.type), '...') }}
              span(style='float: right; color: #8492a6; font-size: 13px') {{ item.type }}
        ods-button(plain size="small" @click="geoCoding()")
          ods-icon(name="search" size="16")
    div
      div.mapSearch__controllers
        transition(name="fade")
          ods-select(
            @change="changeBasemap"
            v-if="showSelectMap"
            v-model="valueMap"
            multiple=false
            size="hecto")
              ods-option(
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value")
        ods-button(plain size="small" @click="baseMap()")
          ods-icon(name="map" size="16")
    div(v-if="!control3D")
      div.mapSearch__controllers
        transition(name="fade")
          ods-select(
            @change="change3D"
            v-if="select3D"
            v-model="value3D"
            multiple=true
            size="hecto")
              ods-option(
                v-for="item in options3D"
                :key="item.value"
                :label="item.label"
                :value="item.value")
        ods-button(plain size="small" @click="showSelect3D()")
          ods-icon(name="disable" size="16")

</template>

<script>

export default {
  name: 'SearchMap',
  data () {
    return {
      value: '',
      mapLoad: false,
      showSelectMap: false,
      select3D: false,
      control3D: this.$store.getters.getbtn3D,
      geocoding: {
        loading: false,
        filteredOptions: [],
        value: '',
        show: false
      },
      options: [],
      valueMap: '',
      options3D: [
        {
          value: 'isCesium3DTileset',
          label: 'Edificios'
        }
      ],
      value3D: null
    }
  },
  computed: {
    getBasemapdata () {
      return this.$store.getters.getBasemap
    },
    getbtn3D () {
      return this.$store.getters.getbtn3D
    }
  },
  watch: {
    getBasemapdata (val) {
      this.updateBasemap(val)
    },
    getbtn3D (val) {
      this.control3D = val
      if (!val) this.change3D()
    }
  },
  methods: {
    change3D () {
      // controlamos primero los edificios
      this.$store.dispatch('updateSelect3D', this.value3D)
      this.controlBuilding()
    },
    controlBuilding () {
      let isCesium3DTileset = 'isCesium3DTileset'
      let encontrado = false
      let isCesium3DTilesetExist = this.value3D.find(elem => elem === isCesium3DTileset)
      if (typeof isCesium3DTilesetExist !== 'undefined') {
        encontrado = true
      }
      var primitives = document.getElementById('dataIframe').contentWindow.viewer.scene.primitives._primitives
      if (primitives) {
        if (primitives.length > 0) {
          primitives.forEach(elem => {
            if (elem[isCesium3DTileset]) {
              elem.show = encontrado
            }
          })
        }
      }
    },
    showSelect3D () {
      this.select3D = !this.select3D
    },
    filter (value) {
      if (value === '') {
        this.geocoding.filteredOptions = []
      }
      this.value = value
    },
    geoCoding () {
      this.geocoding.show = !this.geocoding.show
      this.geocoding.filteredOptions = []
      this.geocoding.value = ''
    },
    baseMap () {
      this.showSelectMap = !this.showSelectMap
    },
    changeBasemap () {
      if (this.$store.getters.getSelectBasemap !== null) {
        this.$store.dispatch('updateSelectBasemap', this.valueMap)
        let sel = this.options.filter(d => d.url === this.valueMap)
        let obj = sel[0]
        document.getElementById('dataIframe').contentWindow.loadBasemap(obj)
        let mapsHeatArray = document.getElementById('dataIframe').contentWindow.viewer.imageryLayers._layers
        for (var i = 0; i < mapsHeatArray.length; i++) {
          if (!mapsHeatArray[i]._imageryProvider.name) {
            document.getElementById('dataIframe').contentWindow.viewer.imageryLayers.lowerToBottom(document.getElementById('dataIframe').contentWindow.viewer.imageryLayers._layers[i])
          }
        }
      }
      // LLAMAR A TU FUNCION
    },

    setIndex (values) {
      return values.map((value) => {
        value.id = 'search' + values.indexOf(value)
        return value
      })
    },
    getType (value) {
      let type = 'address'
      const arrayValue = this.value.split(',')
      if (arrayValue.length === 2) {
        if (/^-?[\d.]+(?:e-?\d+)?$/.test(arrayValue[0].trim()) && /^-?[\d.]+(?:e-?\d+)?$/.test(arrayValue[1].trim())) {
          type = 'reverse'
        }
      }
      return type
    },
    search (value) {
      const vm = this
      this.geocoding.loading = true
      const typeGeocoding = this.getType(value)
      const geocodingConfig = {
        type: typeGeocoding,
        // address: 'Calle Obispo Rabadán',
        // address: 'Calle Perojo, 17',
        address: this.value,
        position: this.value,
        candidates: 5
      }
      document.getElementById('dataIframe').contentWindow.geocoding(geocodingConfig)
        .then(response => { vm.geocoding.filteredOptions = vm.setIndex(response) })
        .then(vm.geocoding.loading = false)
    },
    setZoom (value) {
      const current = this.geocoding.filteredOptions.filter((option) => option.id === value)[0]
      document.getElementById('dataIframe').contentWindow.zoomGeocoding(current)
      this.geocoding.filteredOptions = []
    },
    calculateLength (type) {
      return type === 'point of interest' ? 72 : 80
    },
    updateBasemap (optionsArray) {
      if (optionsArray.length > 0) {
        optionsArray.forEach((e, index) => {
          if (this.$store.getters.getSelectBasemap !== null) {
            this.valueMap = this.$store.getters.getSelectBasemap
          } else {
            // cambiar por
            // if (e.default)
            if (index === 0) {
              this.$store.dispatch('updateSelectBasemap', e.url)
            }
          }
          e.value = e.url
        })
        this.options = optionsArray
        this.valueMap = this.$store.getters.getSelectBasemap
      }
    }
  },
  mounted () {
    this.value3D = this.$store.getters.getSelectValue3D
    let optionsArray = this.$store.getters.getBasemap
    if (optionsArray !== null) this.updateBasemap(optionsArray)
    // this.init()
  }
}

</script>

<style lang="scss" scoped>

.mapSearch {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-end;
  opacity: 1;
  transition: opacity 0.5s;
  &__selector {
    position: relative;
    margin: 0;
    padding: 0;
    + .mapSearch__controllers {
      margin-top: 8px;
      margin-bottom: 8px;
    }
  }
  /deep/ .ods-button > i{
    margin-left: 0;
  }
  & > div {
    display: block;
    width: 100%;
  }
  &__controllers {
    margin-top: 5px;
    position: relative;
    display: flex;
    justify-content: flex-end;
    &::after {
      content: "";
      display: block;
      position: absolute;
      margin: 10px 0;
      left: 40px;
      /* left: 6px; */
      width: 1px;
      height: 16px;
      background-color: $--color-neutral-3;
      pointer-events: none;
    }
    .ods-button [class*="ods-icon-"]{
      margin-left: 0;
    }
    .ods-button {
      margin: 0;
      padding: 0;
      width: 32px;
      height: 32px;
      border-radius: 0;
      background-color: $--color-white;
      border-radius: 2px 0 0 2px;
      border: 0;
      cursor: pointer;
      outline: 0;
      &:hover {
        background: $--color-primary;
        color: $--color-white;
      }
      &:focus,
      &:active {
        background: $--color-white;
        color: $--color-primary;
      }

      &[class*="ods-icon-"] {
        margin-left: 0;
      }
      + .ods-button {
        border-radius: 0 2px 2px 0;
        margin-left: 1px;
        box-shadow: none;
        & > i {
          margin-left: 0;
        }
        [class*="ods-icon-"]{
          margin-left: 0;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SearchMap.vue